<template>
	<c-dialog ref="dialog" width="550" height="400" @resolve="borrowAssetHandle">
		<c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="asset_ids"></c-input>
			<c-form-item :label="type==1?'借用资产':'转移资产'">
                <c-input type="textarea" name="asset_names" maxlength="500" disabled></c-input>
            </c-form-item>
            <c-form-item label="借用网点" required tip="请选择借用当前资产的网点，借用网点不能与所属网点相同" v-if="this.type == 1">
                <c-select name="borrow_outlet_id" async @search="searchOutlet"></c-select>
            </c-form-item>
            <c-form-item label="接收网点" required tip="请选择接收当前资产的网点，接收网点不能与当前所属网点相同" v-if="this.type == 3">
                <c-select name="new_outlet_id" async @search="searchOutlet"></c-select>
            </c-form-item>
        </c-form>
	</c-dialog>
</template>
<script>
	import {mapState} from "vuex";

    export default {
		data() {
			return {
                type:1          //操作类型  1=借用  3=转移
			}
		},
        computed: {
        },
		methods: {
			/************打开弹框**************/
			open(data) {
                this.type = data.type||1;
				this.$refs.form.clear();
				if (data) {
                    this.$refs.form.set({
                        asset_ids: data.asset_ids,
                        asset_names: data.asset_names,
                    });
                }
				//填充form表单
				this.$refs.dialog.open({
					title: this.type==1?'资产借用':'资产转移'
				});
			},

            /*******搜索网点*****************/
            searchOutlet(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'AFTERSALE_OUTLET',
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },

			/************资产借用提交处理方法*******************************/
            borrowAssetHandle (stop, next){
				stop();
				this.$refs.form.submit({
					url: this.type == 1?'/fixed_asset/borrow':'/fixed_asset/transfer',
					dataFormatter: data => {
						return data;
					},
					rule: {
                        asset_ids: '请至少选择一条资产记录',
                        borrow_outlet_id: [{
                            type: 'empty',
                            message: '请选择借用资产的网点',
                            skip: () => {
                                return this.type!=1;
                            }
                        }],
                        new_outlet_id: [{
                            type: 'empty',
                            message: '请选择接收资产的网点',
                            skip: () => {
                                return this.type!=3;
                            }
                        }]
					},
					success: (data, res) => {
						next();
						this.$message({
							message: '借用成功',  // 提示内容,
							type: 'success'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>